export interface ICartSettings {
  giftPackaging: IGiftPackagingSettings;
  ecoPackagingEnabled: boolean;
  insuranceEnabled: boolean;
  ecoPackagingPrice: number;
  giftPackagingPrice: number;
  insurancePrice: number;
  giftPackagingLinkUrl: string;
  loyaltyModalImageUrl: string;
  fundRaising: IFundRaisingSettings;
  discoveryBox: IDiscoveryBoxSettings;
  showGiftSelectionByDefault: boolean;
  insuranceLinkUrl: string;
  voucherUnderProductEnabled: boolean;
}

export interface IDiscoveryBoxSettings {
  image?: string | null;
}

export interface IFundRaisingSettings {
  price: number;
  active: boolean;
  image?: string | null;
}

export interface IGiftPackagingSettings {
  giftPackagingOn: boolean;
  maxBoxes: number;
  maxProductInBox: number;
  giftPackagingTypes: IGiftPackagingBoxSettings[];
  giftCardEnabled: boolean;
  giftCardTextLimit: number;
}

export interface IGiftPackagingBoxSettings {
  id: number;
  name: string;
  isActive: boolean;
  groupName: EServiceGroupName;
  sortOrder: number;
  info?: string | null;
  productCode: string;
  orderPerDay: number;
  stockLimit: number;
  stock: number;
  colorCode?: string | null;
  colorIcon?: string | null;
  image?: string | null;
  vat: number;
  price: number;
}

export interface IBazaarvoiceSettings {
  siteId: string;
  environment: string;
  locale: string;
}

export enum EServiceGroupName {
  GIFT_PACKAGING = 'GiftPackaging',
  ECO_PACKAGING = 'EcoPackaging',
  INSURANCE = 'Insurance',
  ENGRAVING = 'Engraving',
  FUND_RAISING = 'FundRaising',
  DISCOVERY_BOX = 'DiscoveryBox',
}

export const CART_DEFAULT_SETTINGS: ICartSettings = {
  giftPackaging: {
    giftCardEnabled: false,
    giftCardTextLimit: 120,
    giftPackagingOn: false,
    giftPackagingTypes: [],
    maxBoxes: 4,
    maxProductInBox: 4,
  },
  ecoPackagingEnabled: false,
  ecoPackagingPrice: 0,
  insuranceEnabled: false,
  insurancePrice: 0,
  giftPackagingPrice: 0,
  giftPackagingLinkUrl: '',
  loyaltyModalImageUrl: '',
  fundRaising: {
    active: false,
    price: 0,
  },
  discoveryBox: {},
  showGiftSelectionByDefault: false,
  insuranceLinkUrl: '',
  voucherUnderProductEnabled: false,
};
